const datierungen = [
	"",
	"vorgeschichtlich unbestimmt",
	"metallzeitlich unbestimmt",
	"Palaeolithikum",
	"Altpalaeolithikum",
	"Mittelpalaeolithikum",
	"Jungpalaeolithikum",
	"Spaetpalaeolithikum",
	"Mesolithikum",
	"Fruehmesolithikum",
	"Mittelmesolithikum",
	"Spaetmesolithikum",
	"Neolithikum",
	"Altneolithikum",
	"Mittelneolithikum",
	"Jungneolithikum",
	"Endneolithikum",
	"Fruehe Bronzezeit",
	"Bz A1",
	"Bz A2",
	"Bz A2/B1",
	"Mittlere Bronzezeit",
	"Bz B",
	"Bz C1",
	"Bz C2",
	"Spaete Bronzezeit (Bz D)",
	"Urnenfelderzeit",
	"Ha A",
	"Ha B",
	"Hallstattzeit",
	"Mittlere Hallstattzeit (Ha C)",
	"Spaete Hallstattzeit (Ha D)",
	"Latenezeit",
	"Fruehe Latenezeit",
	"Mittlere Latenezeit",
	"Juengere Latenezeit (C/D)",
	"Spaete Latenezeit",
	"fruehgermanisch",
	"augusteisch",
	"Fruehe Kaiserzeit",
	"1. Haelfte 1. Jh.",
	"Mittl. Kaiserzeit bis Limesfall",
	"2. Haelfte 1. Jh.",
	"1. Haelfte 2. Jh.",
	"2. Haelfte 2. Jh.",
	"2.-3. Jh.",
	"3. Jh. bis Limesfall",
	"Spaete Kaiserzeit",
	"nach Limes-Zeit",
	"1.-2. Jh.",
	"1.-3. Jh.",
	"Neckarsueben",
	"2. Haelfte 3. Jh. (260-300)",
	"4. Jh. (301-400)",
	"1. Haelfte 5. Jh. (400-450)",
	"Fruehmittelalter",
	"aelt. Merowingerzeit (450-600)",
	"Jueng. Merowingerzeit (601-720)",
	"karolingisch (8.-9.Jh.)",
	"ottonisch (10.Jh.)",
	"Uebergang Frueh-/Hochmittelalter",
	"10.-11. Jh.",
	"Hochmittelalter",
	"11. Jh.",
	"12. Jh.",
	"Uebergang Hoch-/Spaetmittelalter",
	"12.-13. Jh.",
	"13.-14. Jh.",
	"Spaetmittelalter",
	"13. Jh.",
	"14. Jh.",
	"15. Jh.",
	"14.-15. Jh.",
	"Fruehe Neuzeit (16.-18.Jh.)",
	"Fruehe Neuzeit (16. Jh.)",
	"Fruehe Neuzeit (17. Jh.)",
	"Fruehe Neuzeit (16.-17.Jh.)",
	"Fruehe Neuzeit (18. Jh.)",
	"Moderne (19. Jh.)",
	"Moderne (20. Jh.)",
	"Moderne (21. Jh.)"
]

export default datierungen;
